import script from "./MadarionLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MadarionLogo.vue?vue&type=script&setup=true&lang=ts"

import "./MadarionLogo.vue?vue&type=style&index=0&id=e78ed452&scoped=true&lang=css"

import exportComponent from "/opt/sources/madarion/mdnw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78ed452"]])

export default __exports__